import { createFeatureSelector } from '@ngrx/store';
import { ORDERBUMP_FEATURE_KEY } from './order-bump.reducer';

export const getOrderBumpProductIdList = createFeatureSelector<number[]>(ORDERBUMP_FEATURE_KEY);
